import { useEffect, useState } from "react";
import { toast } from "sonner";
import { ShieldCheck } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Checkbox } from "@/components/ui/checkbox";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg, useApi } from "@/lib/api";

const FIELDS = [["business_name", "Ragione sociale / Nome e cognome *"], ["vat_number", "P.IVA / Codice fiscale *"], ["business_address", "Sede legale *"],
  ["oam_number", "N. iscrizione OAM"], ["privacy_email", "Email / PEC per la privacy"]];

export const DpaGate = () => {
  const { data: st, refetch } = useApi("/dpa/status");
  const { data: settings } = useApi("/settings", { enabled: !!st?.required });
  const [f, setF] = useState({});
  const [ok, setOk] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (settings) setF(Object.fromEntries(FIELDS.map(([k]) => [k, settings[k] || ""]))); }, [settings]);
  if (!st?.required) return null;
  const valid = ok && f.business_name?.trim() && f.vat_number?.trim() && f.business_address?.trim();
  const accept = async () => {
    setBusy(true);
    try { await api.post("/dpa/accept", { accept: true, ...f }); toast.success("DPA accettato, grazie!"); await refetch(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open>
      <DialogContent data-testid="dpa-gate-modal" className="max-w-lg [&>button]:hidden" onInteractOutside={(e) => e.preventDefault()} onEscapeKeyDown={(e) => e.preventDefault()}>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><ShieldCheck className="h-5 w-5 text-emerald-600" />Nuova versione del DPA</DialogTitle>
          <DialogDescription>Abbiamo aggiornato l'Accordo sul trattamento dei dati (versione {st.version}). Per continuare a usare Kreditofacile conferma i tuoi dati e accettalo.</DialogDescription>
        </DialogHeader>
        <div className="grid sm:grid-cols-2 gap-2">
          {FIELDS.map(([k, l]) => <Input key={k} data-testid={`dpa-gate-${k}`} placeholder={l} value={f[k] || ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} />)}
        </div>
        <label className="flex items-start gap-3 text-sm"><Checkbox data-testid="dpa-gate-accept" checked={ok} onCheckedChange={(v) => setOk(!!v)} className="mt-0.5" />
          <span>Ho letto e accetto il nuovo <a href="/dpa" target="_blank" rel="noreferrer" data-testid="dpa-gate-link" className="text-sky-700 underline">Accordo sul trattamento dei dati (art. 28 GDPR)</a>.</span></label>
        <div><Button data-testid="dpa-gate-submit" onClick={accept} disabled={!valid || busy} className="w-full bg-[#0F172A] hover:bg-sky-600">{busy ? "Salvataggio…" : "Accetta e continua"}</Button></div>
      </DialogContent>
    </Dialog>
  );
};
